import { useSelector } from 'react-redux';
import DealerDuck from 'src/redux/dealer/dealer.duck';
import { Redux } from 'src/redux/redux.interface';

export const useDealerDuck = () => {
    const dealer = useSelector((state: Redux) => DealerDuck.getOwnState(state).dealer);

    return { dealer };
};
